/**
 * Business dates.
 *
 * Register §7 ("Strict DATE handling"): a business DATE is a strict Gregorian
 * `YYYY-MM-DD` between 1900-01-01 and 2199-12-31 inclusive, and it is never a
 * JavaScript `Date` (which would introduce a UTC conversion).
 */
const GREGORIAN_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;
export const MIN_BUSINESS_DATE = '1900-01-01';
export const MAX_BUSINESS_DATE = '2199-12-31';
export class InvalidBusinessDateError extends Error {
    name = 'InvalidBusinessDateError';
}
function daysInMonth(year, month) {
    if (month === 2) {
        const leap = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
        return leap ? 29 : 28;
    }
    return [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month - 1] ?? 0;
}
/**
 * Parse a strict Gregorian date within the permitted business range.
 *
 * Throws {@link InvalidBusinessDateError} for a malformed, out-of-range or
 * non-existent calendar date (for example `2026-02-30`).
 */
export function parseBusinessDate(value) {
    const match = typeof value === 'string' ? GREGORIAN_DATE.exec(value) : null;
    if (match === null) {
        throw new InvalidBusinessDateError(`not a YYYY-MM-DD date: ${JSON.stringify(value)}`);
    }
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    if (month < 1 || month > 12 || day < 1 || day > daysInMonth(year, month)) {
        throw new InvalidBusinessDateError(`not a real calendar date: ${value}`);
    }
    if (value < MIN_BUSINESS_DATE || value > MAX_BUSINESS_DATE) {
        throw new InvalidBusinessDateError(`outside ${MIN_BUSINESS_DATE}..${MAX_BUSINESS_DATE}: ${value}`);
    }
    return { year, month, day };
}
//# sourceMappingURL=date.js.map